class phoneNumber extends HTMLElement {
  connectedCallback() {
    this._phoneNumber();
  }

  get inputElement() {
    return this.querySelector('input');
  }

  _phoneNumber() {
    const isUK = window.shop?.storeCountryConfig === 'uk';

    const iti = window.intlTelInput(this.inputElement, {
      initialCountry: isUK ? "gb" : "fr",
      preferredCountries: isUK ? ["gb", "fr", "be", "nl"] : ["fr", "be", "nl"],
      autoPlaceholder: "aggressive",
      nationalMode: false,
      utilsScript: window.shop.intlTel.intlTelInputUtils,
    });
  }
}

try {
  window.customElements.define('phone-number', phoneNumber);
} catch (e) { }